import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneDaySelected(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const selectedDays = control.value as boolean[];
        if (selectedDays && selectedDays.some((day) => day === true)) {
            return null;
        }
        return { atLeastOneSelected: true };
    };
}